import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=3c45df33"
import script from "./Drawers.vue?vue&type=script&lang=js"
export * from "./Drawers.vue?vue&type=script&lang=js"
import style0 from "./Drawers.vue?vue&type=style&index=0&id=3c45df33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports